// Dependencies
import { FC } from "react";

// Components
import { WalletForm } from "~/components/Layout/LayoutForm";

// Types
import { TWalletDetailData } from "~/types/types";

// Styles
import {
  StyledInfoLabel,
  StyledInfoWrapper,
} from "../../Layout/LayoutInfo/LayoutInfo.styled";

interface WalletEditProps {
  onCancel: Function;
  onSubmit: Function;
  initialData: TWalletDetailData | undefined;
}

const WalletEdit: FC<WalletEditProps> = (props) => {
  return (
    <StyledInfoWrapper>
      <StyledInfoLabel key={1}>Edit Wallet</StyledInfoLabel>
      <WalletForm key={2} {...props} type={props.initialData?.type || ""} />
    </StyledInfoWrapper>
  );
};

export default WalletEdit;
